import React from "react";
import styled from "styled-components";

export default function Contact() {
  return (
    <Wrapper id="contact">
      <div className="lightBg">
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold">Let's get in touch</h1>
            <p className="font13">
              Reach us directly via phone or email. We’d love to hear from you!
            </p>
          </HeaderInfo>

          <Content className="row" style={{ paddingBottom: "30px" }}>
            {/* Contact Info */}
            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <ContactDetails>
                <IconRow>
                  <PhoneIcon
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="currentColor"
                      d="M6.62 10.79a15.053 15.053 0 006.59 6.59l2.2-2.2a1 1 0 011.01-.24c1.12.37 2.33.57 3.58.57.55 0 1 .45 1 1V20c0 
                      .55-.45 1-1 1C10.07 21 3 13.93 3 5c0-.55.45-1 1-1h3.5c.55 
                      0 1 .45 1 1 0 1.25.2 2.46.57 3.59.11.33.03.7-.24 
                      1.01l-2.21 2.19z"
                    />
                  </PhoneIcon>
                  <p>
                    <a href="tel:+97167044236">+971 6 704 4236</a>
                  </p>
                </IconRow>

                <IconRow>
                  <MailIcon
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="currentColor"
                      d="M20 4H4c-1.1 0-2 .9-2 
                      2v12c0 1.1.9 2 2 2h16c1.1 
                      0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 
                      4l-8 5-8-5V6l8 5 8-5v2z"
                    />
                  </MailIcon>
                  <p>
                    <a href="mailto:contact@samaalfalah.com">
                      contact@samaalfalah.com
                    </a>
                  </p>
                </IconRow>
              </ContactDetails>
            </div>

            {/* Right Side Placeholder */}
            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 flex">
              <RightSide>
                <h3>📍 Location</h3>
                <p>Industrial Area 5 - Sharjah, UAE</p>
              </RightSide>
            </div>
          </Content>
        </div>
      </div>
    </Wrapper>
  );
}

/* ================= Styles ================= */
const Wrapper = styled.section`
  width: 100%;
`;

const HeaderInfo = styled.div`
  padding: 70px 0 30px 0;
  text-align: center;
`;

const Content = styled.div`
  display: flex;
  align-items: flex-start;
`;

const ContactDetails = styled.div`
  padding: 40px 0;
  p {
    margin: 0;
    font-size: 16px;
    color: #555;
  }
  a {
    color: #7620ff;
    text-decoration: none;
    font-weight: 600;
  }
  a:hover {
    color: #580cd2;
  }
`;

const IconRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  gap: 12px;
`;

const PhoneIcon = styled.svg`
  width: 28px;
  height: 28px;
  color: #7620ff;
`;

const MailIcon = styled.svg`
  width: 28px;
  height: 28px;
  color: #7620ff;
`;

const RightSide = styled.div`
  padding: 40px;
  h3 {
    margin-bottom: 10px;
    font-size: 18px;
    color: #000;
  }
  p {
    font-size: 15px;
    color: #555;
  }
`;
